<div class="tabs-panel" data-crlat="panel.tabs">
    <div class="scroll-container" scrollable [rescrollOnChange]="tpActiveTab?.id">
        @if (tpTabs.length) {
            <ul [ngClass]="{ 'flex-tabs': tbClass }" class="scroll-inner" data-crlat="tabs">
                @for (tab of tpTabs; track $index) {
                    @if (!tab.hidden) {
                        <li [ngClass]="{ active: setActiveClass(tab), disabled: tab.disabled }" data-crlat="tab.tpTabs">
                            <a
                                class="tab"
                                (click)="clickFunction(tab, $event)"
                                [attr.href]="tab.url"
                                [ngClass]="{ 'tab-byb-icon': tab.bybAvb === true }"
                                data-crlat="tab">
                                @if (tab.isFiveASideNewIconAvailable) {
                                    <span class="badge-new">NEW</span>
                                }
                                @if (tab.bybAvb) {
                                    @if (setActiveClass(tab)) {
                                        <svg class="byb-label" *ngIf="setActiveClass(tab)">
                                            <use xlink:href="#tab-byb-icon-active"></use>
                                        </svg>
                                    } @else {
                                        <svg class="byb-label">
                                            <use xlink:href="#tab-byb-icon"></use>
                                        </svg>
                                    }
                                }
                                @if (tab.iconId) {
                                    <svg class="tab-icon">
                                        <use [attr.xlink:href]="tab.iconId"></use>
                                    </svg>
                                }
                                <span [textContent]="tab.title"></span>
                            </a>
                        </li>
                    }
                }
            </ul>
        }
    </div>
</div>
